import { useId } from 'react'

// LARPup mark: the letters L and P as one clean shape on a dark tile, filled with a gold-to-pink-to-purple gradient.
// Drawn in code, so it stays sharp at any size and matches the brand colours.
export default function Logo({ size = 60 }: { size?: number }) {
  const id = useId()
  const letters = 'M39 44H65V126H107V152H39Z M117 44H139Q161 44 161 77Q161 110 139 110H143V152H117Z M127 66H137Q145 66 145 77Q145 88 137 88H127Z'

  return (
    <svg viewBox="0 0 200 200" width={size} height={size} role="img" aria-label="LARPup" className="logo-mark">
      <defs>
        <linearGradient id={`${id}-fill`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f3dc97" />
          <stop offset="0.5" stopColor="#e2369b" />
          <stop offset="1" stopColor="#7c3aed" />
        </linearGradient>
        <linearGradient id={`${id}-tile`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1d2330" />
          <stop offset="1" stopColor="#0b0d12" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="200" height="200" rx="46" fill={`url(#${id}-tile)`} />
      <rect x="1" y="1" width="198" height="198" rx="45" fill="none" stroke={`url(#${id}-fill)`} strokeOpacity="0.45" strokeWidth="2" />
      <path d={letters} fill={`url(#${id}-fill)`} fillRule="evenodd" />
    </svg>
  )
}
